const BASE = '/panel/db_performance';

export const dbPerformanceRequest = async (path, {method = 'GET', body, signal} = {}) => {
    const response = await fetch(`${process.env.REACT_APP_API_URL}${BASE}${path}`, {
        method,
        headers: {
            'Content-Type': 'application/json; charset=UTF-8',
            Authorization: sessionStorage.getItem('agronetToken'),
            Local: localStorage.getItem('lang') || 'en'
        },
        signal,
        ...(body !== undefined ? {body: JSON.stringify(body)} : {})
    });
    if (!response.ok) throw new Error(String(response.status));
    const text = await response.text();
    return text ? JSON.parse(text) : null;
};

export const formatMs = value => {
    if (value === null || value === undefined || !Number.isFinite(Number(value))) return '—';
    const ms = Number(value);
    if (ms >= 1000) return `${(ms / 1000).toFixed(2)} s`;
    if (ms >= 100) return `${ms.toFixed(0)} ms`;
    if (ms >= 1) return `${ms.toFixed(1)} ms`;
    return `${ms.toFixed(3)} ms`;
};

export const formatBytes = value => {
    if (value === null || value === undefined || !Number.isFinite(Number(value))) return '—';
    const units = ['B', 'kB', 'MB', 'GB', 'TB'];
    let size = Number(value);
    let unit = 0;
    while (size >= 1024 && unit < units.length - 1) {
        size /= 1024;
        unit++;
    }
    return unit === 0 ? `${size} B` : `${size.toFixed(1)} ${units[unit]}`;
};

export const groupTestsByCategory = tests => {
    const groups = [];
    (tests || []).forEach(test => {
        let group = groups.find(g => g.category === test.category);
        if (!group) {
            group = {category: test.category, tests: []};
            groups.push(group);
        }
        group.tests.push(test);
    });
    return groups;
};

export const defaultSelection = tests => new Set((tests || []).filter(t => t.defaultSelected).map(t => t.key));

const integerIn = (value, min, max) => {
    const number = Number(value);
    return value !== '' && Number.isInteger(number) && number >= min && number <= max ? number : null;
};

export const buildRunRequest = (form, selectedKeys, tests) => {
    const parameterSetId = integerIn(form.parameterSetId, 1, Number.MAX_SAFE_INTEGER);
    if (parameterSetId === null) throw new Error('Select a parameter set.');
    const testKeys = (tests || []).map(t => t.key).filter(key => selectedKeys.has(key));
    if (testKeys.length === 0) throw new Error('Select at least one test.');
    const iterations = integerIn(form.iterations, 1, 100);
    const warmup = integerIn(form.warmup, 0, 20);
    const timeoutSeconds = Number(form.timeoutSeconds);
    if (iterations === null || warmup === null || form.timeoutSeconds === '' ||
        !(timeoutSeconds >= 0.1 && timeoutSeconds <= 600)) {
        throw new Error('Iterations 1–100, warm-up 0–20, timeout 0.1–600 s.');
    }
    const text = value => (value && value.trim() ? value.trim() : null);
    return {parameterSetId, label: text(form.label), notes: text(form.notes), testKeys, iterations, warmup,
        statementTimeoutMs: Math.round(timeoutSeconds * 1000)};
};

export const summarizeComparison = rows => {
    const summary = {faster: 0, slower: 0, same: 0, other: 0, planChanged: 0, baseTotalMs: 0, targetTotalMs: 0};
    (rows || []).forEach(row => {
        const comparable = ['FASTER', 'SLOWER', 'SAME'].includes(row.verdict);
        if (row.verdict === 'FASTER') summary.faster++;
        else if (row.verdict === 'SLOWER') summary.slower++;
        else if (row.verdict === 'SAME') summary.same++;
        else summary.other++;
        if (row.planChanged) summary.planChanged++;
        // totals only over tests that succeeded in both runs, so they are comparable
        if (comparable) {
            summary.baseTotalMs += Number(row.baseMedianMs) || 0;
            summary.targetTotalMs += Number(row.targetMedianMs) || 0;
        }
    });
    return summary;
};

export const isRunActive = run => !!run && (run.status === 'QUEUED' || run.status === 'RUNNING');
